import { render, staticRenderFns } from "./AlipayIdImageUpdate.vue?vue&type=template&id=4f207556&scoped=true"
import script from "./AlipayIdImageUpdate.vue?vue&type=script&lang=js"
export * from "./AlipayIdImageUpdate.vue?vue&type=script&lang=js"
import style0 from "./AlipayIdImageUpdate.vue?vue&type=style&index=0&id=4f207556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f207556",
  null
  
)

export default component.exports